<template>
  <div class="menuMore" :style="{ 'paddingTop': statusBar - 0.04 + 'rem' }" ref="menuMorePaddingTop">
    <!-- <Header title="国际贸易单一窗口标准版" :back="true" left="首页" right="管理" :white="true" @rightC="rightC()" /> -->
    <Headerd v-if="headerShow" title="国际贸易单一窗口标准版" :back="true" :backInitHome="true" left="返回" right="管理" :white="true"
      :paddingTopHeight="statusBar" @rightC="rightC()" @leftC="leftC()" ref="headheight" />
    <div class="menuMoremain">
      <div class="myAppList" ref="getheight">
        <van-collapse v-model="collapseName">
          <van-collapse-item title="测试" name="1">
            <template #title>
              <div style="padding-top:5px">
                <p class="title1" style="float:left">我的应用</p>
                <p style="text-align:center;font-size:14px;line-height:16px;color:#767676;margin-top:1px">
                  点击{{ showp }}您的{{ shownn }}个应用</p>
              </div>
            </template>
            <ul style="padding-bottom: 10px;">
              <li v-for="(v, i) in myApp" :key="i" @click="gotoSmall(v.appUrl, v.appId)"
                :class="[i % 4 === 0 ? 'borderLeft' : '', myApp.length % 4 === 0 ? ((myApp.length - 5) <= i ? 'borderBottom' : '') : ((myApp.length - (myApp.length % 4)) <= i ? 'borderBottom' : '')]">
                <img v-if="v.appIcon" :src="v.appIcon" alt class="imgApp" style="width: 24px;height: 24px;">
                <img v-if="v.isNew === '1'" class="newImg" src="@/views/image/icon_new_application.png" alt />
                <img v-if="v.isHot === '1'" class="newImg" src="@/views/image/icon_hot_application.png" alt />
                <span v-html="v.appName"></span>
              </li>
            </ul>
          </van-collapse-item>
        </van-collapse>

      </div>

      <div v-for="(items, i) in this.menuList" :key="i" class="list" style="margin-top:10px">

        <div v-for="(item, i) in items.firstarr" :key="i" style="margin:6px 0;background:#fff " @click="tPinglun(i)"
          ref='i'>
          <div class="BiztypeDetailbg" style="border-bottom:1px solid #f3f7ff">
            <div class="BiztypeDetail" style="margin-top:6px;border-bottom:1px solid #f3f7ff">
              <p>{{ item.appBiztypeName }}</p>
            </div>
          </div>
          <ul>
            <li v-for="(v, index) in item.arr" :key="index" @click="gotoSmall(v.appUrl, v.appId)"
              :class="[index % 4 === 0 ? 'borderLeft' : '', item.arr.length % 4 === 0 ? ((item.arr.length - 5) <= i ? 'borderBottom' : '') : ((item.arr.length - (item.arr.length % 4)) <= i ? 'borderBottom' : '')]">
              <img v-if="v.appIcon" :src="v.appIcon" alt class="imgApp" style="width: 24px;height: 24px;">
              <img v-if="v.isNew === '1'" class="newImg" src="@/views/image/icon_new_application.png" alt />
              <img v-if="v.isHot === '1'" class="newImg" src="@/views/image/icon_hot_application.png" alt />
              <span v-html="v.appName"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/views/css/resetVui.scss";
import "./menu.scss";
import Headerd from "@/components/Headerd";
import {
  Grid,
  GridItem,
  Tab,
  Tabs,
  Sticky,
  Col,
  Row,
  Collapse,
  CollapseItem,
} from "vant";
export default {
  name: "home",
  /**
   * 初始化数据
   */
  data() {
    return {
      tabHeight: 0,
      menuList: [],
      myApp: [],
      statusBar: 0,
      statusBars: 0,
      backormoren: true,
      isLoad: "0",
      myAppHeight: "",
      headerShow: true,
      active: 0,
      collapseName: [],
      showp: "展开",
      shownn: "1",
      kong: [],
    };
  },
  /**
   * 初始化
   */
  mounted() {

    //console.log(this.$refs.getheight.offsetHeight);
    this.statusBar = this.$tool.statusBar(42);
    this.statusBars = this.$tool.statusBar(274);

    this.$refs.menuMorePaddingTop.style.paddingTop = this.statusBar + "rem";

    window.backData = this.backData;
    this.getMyselfApps();
    window.getMyselfApps = this.getMyselfApps;
    // setTimeout(() => {
    //   this.myAppHeight = this.$refs.getheight.offsetHeight + 80;
    //   console.log("mmmmmyAppHeight初始f " + this.myAppHeight);
    // }, 0);
    //console.log(this.$refs.headheight.$el.offsetHeight);

    window.addEventListener("scroll", this.handleScroll, true);

  },
  watch: {
    //hotkeyList渲染完后，获取高度
    myApp() {
      this.shownn = this.myApp.length;
      this.$nextTick(function () {
        setTimeout(() => {
          this.tabHeight = this.$refs.headheight.$el.offsetHeight;
          this.myAppHeight = this.$refs.getheight.offsetHeight + 20;

          window.scroll(0, 0);
          // console.log(window.scrollY);
        }, 0);
        setTimeout(() => {
          // console.log("最后执行");
          window.scroll(0, 0);
        }, 20);
      });
    },
    collapseName() {
      if (this.collapseName[0] == 1) {
        this.showp = "收起";
      } else {
        this.showp = "展开";
      }
      //console.log();
    },
    active() {
      if (this.active == 2) {
        //console.log("===============");
        // window.scrollTo({
        //   top: 300,
        // });
      }
    },
    //路由回调刷新
    statusBar() {
      this.headerShow = false;
      this.$nextTick(function () {
        this.statusBar = this.$tool.statusBar(42);
        this.headerShow = true;
        //console.log(sessionStorage.getItem("statusBar") + "bbbbccc ");
      });
    },
  },

  /**
   * 方法
   */
  methods: {
    BrmyAppFunction() {
      for (let i in this.myApp) {
        this.myApp[i].appName = this.myApp[i].appName.replace(/\|\|/g, "<br/>");
      }
    },
    BrmyListFunction() {
      for (let i in this.menuList[0].firstarr) {
        for (let j in this.menuList[0].firstarr[i].arr) {
          this.menuList[0].firstarr[i].arr[
            j
          ].appName = this.menuList[0].firstarr[i].arr[j].appName.replace(
            /\|\|/g,
            "<br/>"
          );
        }
      }
    },
    handleScroll(el) {
      //console.log(this.$refs.i.length);
      let centerhei = document.documentElement.clientHeight / 2;
      //console.log(centerhei);
      //console.log(this.$refs.i.length);
      for (var a = 0; a < this.$refs.i.length; a++) {
        let _pos = this.$refs.i[a].getBoundingClientRect().top;
        //console.log(_pos);
        if (_pos < centerhei + 5 && _pos > centerhei - 5) {
          this.active = a;
        }
      }
    },
    _initData() {
      window.scroll(0, 0);
    },
    backData(val) {
      this.statusBar = val;
      sessionStorage.setItem("statusBar", val);
    },
    toPinglun(g) {
      //this.$refs[i].scrollIntoView(true);

      // this.$refs.i[g].scrollIntoView({
      //   behavior: "smooth",
      //   block: "center",
      // });
      this.$refs.i[g].scrollIntoView({
        // behavior: "smooth",
        block: "center",
      });
      this.active = g;
      //console.log(g);
    },
    tPinglun(g) {
      //this.$refs[i].scrollIntoView(true);
      // console.log(g);
      //this.$refs.i[g].scrollIntoView(true);
      //console.log();
    },

    /**
     * 获取自己的app
     */
    getMyselfApps() {
      this.$http1
        .post("/zsdyckserver/app/Auth/getMobileApps", {})
        .then((res) => {
          if (res.resultFlag === "1") {
            this.menuList = this.dataRecom(res.resultData.allApp);
            this.myApp = res.resultData.myApp;

            this.BrmyListFunction();
            this.BrmyAppFunction();
            //         this.menuList = res.resultData.myApp;
            this.isLoad = "1";
            //        this.getMobileApps();
          }
        })
        .catch((err) => {
          if (err === 302) {
            //console.log(err);
            this.getMobileApps();
            this.isLoad = "0";
          }
        });
    },

    /**
     * 跳转小应用
     */
    gotoSmall(val, id) {
      this.$http1.get("/zsdyckserver/app/access/" + id).then((res) => {
        console.log(res);
      });
      let arr = val.split(":");
      if (arr[0] === "js") {
        this.$tool.callModule(arr[1]);
      } else {
        if (val === "") {
          // this.$toast('敬请期待哟！');
        } else {
          window.location.href = `${window.location.origin}/${val}`;
          // this.$tool.sessionData('#1e3cd2', 'true');
        }
      }
    },
    /**
     * 获取首页menu数据
     */
    getMobileApps() {
      this.$http.post("/zsdyckserver/app/getAllMobileApps").then((res) => {
        if (res.resultFlag === "1") {
          this.menuList = this.dataRecom(res.resultData.allApp);
          this.kong = this.testArr(res.resultData.allApp);
          console.log(this.testArr(res.resultData.allApp));
          console.log(this.dataRecom(res.resultData.allApp));

          console.log(this.menuList);
          this.myApp = res.resultData.myApp;
          //console.log(this.myApp);
          this.BrmyListFunction();
          this.BrmyAppFunction();
        }
      });
    },
    /**
     * 测试数据重组 kong
     */
    testArr(values) {
      let firstarr = [];
      console.log(values);
      values.map((val) => {
        if (firstarr.findIndex((v) => v.appBizType === val.appBizType) === -1) {
          let obj = {
            appBizType: val.appBizType,
            appBiztypeName: val.appBiztypeName,
            arr: new Array(),
          };
          firstarr.push(obj);
        }
      });
      console.log(firstarr);
      firstarr.map((val) => {
        console.log(val.appBizType);
        values.map((v) => {
          if (val.appBizType == v.appBizType) {
            val.arr.push(v);
          }
        });
      });

      return firstarr;
    },
    /**
     * 数据重组
     */
    dataRecom(values) {
      let firstarr = [];
      values.map((val) => {
        val.nullType = 1;
        if (
          firstarr.findIndex(
            (v) => v.appFirstBizType === val.appFirstBizType
          ) === -1
        ) {
          let obj = {
            appFirstBizType: val.appFirstBizType,
            appFirstBiztypeName: val.appFirstBiztypeName,
            firstarr: new Array(val),
          };
          firstarr.push(obj);
        } else {
          firstarr[
            firstarr.findIndex((v) => v.appFirstBizType === val.appFirstBizType)
          ].firstarr.push(val);
        }
      });
      firstarr.map((vv) => {
        let arr = [];
        vv.firstarr.map((val) => {
          val.nullType = 1;
          if (arr.findIndex((v) => v.appBizType === val.appBizType) === -1) {
            let obj = {
              appBizType: val.appBizType,
              appBiztypeName: val.appBiztypeName,
              arr: new Array(val),
            };
            arr.push(obj);
          } else {
            arr[arr.findIndex((v) => v.appBizType === val.appBizType)].arr.push(
              val
            );
          }
        });
        vv.firstarr = arr;
      });

      firstarr.map((vv) => {
        vv.firstarr.map((val) => {
          if (val.arr.length % 4 === 0) {
            return val;
          } else {
            let obj = {
              appIcon: "",
              appName: "",
              appUrl: "",
              nullType: 0,
            };
            let len = 4 - (val.arr.length % 4);
            for (let index = 0; index < len; index++) {
              val.arr.push(obj);
            }
            return val;
          }
        });
      });
      return firstarr;
    },
    /**
     * 右边点击
     */
    rightC() {
      this.backormoren = false;
      window.location.href = `${window.location.origin}/zswebserver/authapp/dist/#/menuMoreupdate`;
      //this.$router.push('/menuMoreupdate');
      // this.$tool.sessionData('#ffffff', 'true');
    },
    /**
     * 左边点击
     */
    leftC() {
      this.backormoren = false;
      this.$router.push(
        "/swdesk?backData=" + sessionStorage.getItem("statusBar")
      );
      // this.$tool.sessionData('#ffffff', 'true');
    },
  },
  // beforeDestroy() {
  //   if(this.backormoren){
  //     this.$tool.beforeDestroy(1);
  //   }
  // },
  components: {
    Headerd,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Sticky.name]: Sticky,
    [Col.name]: Col,
    [Row.name]: Row,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
  },
};
</script>

<style scoped lang="scss">
</style>

